import { adminHttpClient } from '../../../commons/adminHttpClient'

export type GetSeatCountStatisticsResponse = {
  occupiedSeats: number
  totalSeatCount: number
  nextSeat?: NextSeatResponse
}

type NextSeatResponse = {
  startDate: Date
  seatNumber: number
}

export const getSeatCountStatistics = (planPeriodId: string): Promise<GetSeatCountStatisticsResponse> => {
  return adminHttpClient.get(`/AdminDashboard/Seat/GetSeatCountStatistics/${planPeriodId}`)
}
